/* eslint-disable import/prefer-default-export */
import { i18nMark } from 'lingui-react';

import { CASE_STATUS } from 'compositions/CaseStatus/constants';

const statusChanged = i18nMark('changed the status to');

export const messageForStatus = {
  [CASE_STATUS.new]: i18nMark('created case {caseNumber}'),
  [CASE_STATUS.dispatched]: statusChanged,
  [CASE_STATUS.dispatch]: statusChanged,
  [CASE_STATUS.enRoute]: statusChanged,
  [CASE_STATUS.arrived]: statusChanged,
  [CASE_STATUS.rolling]: statusChanged,
  [CASE_STATUS.closed]: statusChanged,
  [CASE_STATUS.canceled]: statusChanged,
};



// WEBPACK FOOTER //
// ./src/compositions/CaseActivityPanel/StatusUpdates/constants.js